import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/admin-img/date-blue.svg'
import _imports_1 from '@/assets/images/admin-img/tags-close-icon.svg'
import _imports_2 from '@/assets/images/admin-img/pdf-icon.svg'
import _imports_3 from '@/assets/images/admin-img/download-icon.svg'
import _imports_4 from '@/assets/images/admin-img/demo-img/logo.png'
import _imports_5 from '@/assets/images/admin-img/light_delete-outline.svg'
import _imports_6 from '@/assets/images/admin-img/light_w-outline.svg'
import _imports_7 from '@/assets/images/admin-img/hired.svg'
import _imports_8 from '@/assets/images/admin-img/reject.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-3b110aa9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "admin-mid-container" }
const _hoisted_3 = {
  class: "admin-custom-row admin-page-row",
  id: "leftMenuSlideBox"
}
const _hoisted_4 = { class: "admin-right-sidebar" }
const _hoisted_5 = { class: "admin-right-sidebar-in" }
const _hoisted_6 = { class: "admin-right-sidebar-in-top" }
const _hoisted_7 = { class: "admin-custom-row" }
const _hoisted_8 = { class: "admin-right-sidebar-in-top-left" }
const _hoisted_9 = { class: "admin-page-type-links" }
const _hoisted_10 = { class: "admin-right-sidebar-in-top-right" }
const _hoisted_11 = { class: "admin-right-sidebar-in-top-right-top" }
const _hoisted_12 = { class: "admin-search-box" }
const _hoisted_13 = { class: "admin-right-sidebar-in-top-right-btm" }
const _hoisted_14 = { class: "tags" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Last Week ", -1))
const _hoisted_19 = { key: 3 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Last Month", -1))
const _hoisted_21 = {
  key: 0,
  class: "delete-all-btn-link"
}
const _hoisted_22 = {
  key: 1,
  class: "delete-all-btn-link"
}
const _hoisted_23 = { class: "date-filter-icon" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = { class: "date-filter-dropdown-in" }
const _hoisted_27 = { class: "custom-date-picker" }
const _hoisted_28 = { class: "action-buttons" }
const _hoisted_29 = {
  class: "admin-item-list-section-in",
  ref: "scrollWrapper",
  "data-simplebar": ""
}
const _hoisted_30 = { class: "admin-item-list-section-scroll" }
const _hoisted_31 = { class: "admin-item-list-top" }
const _hoisted_32 = { class: "admin-item-list-row" }
const _hoisted_33 = { class: "admin-item-checkbox" }
const _hoisted_34 = { class: "admin-checkbox-input" }
const _hoisted_35 = ["checked"]
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "selectAll" }, null, -1))
const _hoisted_37 = { class: "admin-item-image" }
const _hoisted_38 = { class: "admin-item-team-name" }
const _hoisted_39 = { class: "admin-item-team-email" }
const _hoisted_40 = { class: "admin-item-join-team-designation" }
const _hoisted_41 = { class: "admin-item-team-reference" }
const _hoisted_42 = { class: "admin-item-team-join-description" }
const _hoisted_43 = { class: "admin-item-team-status" }
const _hoisted_44 = { class: "admin-item-team-date" }
const _hoisted_45 = { class: "admin-item-actions" }
const _hoisted_46 = { class: "admin-item-list-btm" }
const _hoisted_47 = { ref: "sortableList" }
const _hoisted_48 = { class: "admin-item-box-top" }
const _hoisted_49 = { class: "admin-item-list-row" }
const _hoisted_50 = { class: "admin-item-checkbox" }
const _hoisted_51 = { class: "admin-checkbox-input" }
const _hoisted_52 = ["id", "onChange", "checked"]
const _hoisted_53 = ["for"]
const _hoisted_54 = { class: "admin-item-image" }
const _hoisted_55 = { class: "sm-img" }
const _hoisted_56 = ["src"]
const _hoisted_57 = { class: "admin-item-team-name" }
const _hoisted_58 = { class: "limited-text text-limit" }
const _hoisted_59 = { class: "admin-item-team-email" }
const _hoisted_60 = { class: "admin-item-join-team-designation text-limit" }
const _hoisted_61 = { class: "admin-item-team-reference" }
const _hoisted_62 = { class: "admin-item-team-join-description text-limit" }
const _hoisted_63 = { class: "admin-item-team-status" }
const _hoisted_64 = { class: "status-select-box" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = ["selected"]
const _hoisted_67 = ["selected"]
const _hoisted_68 = ["selected"]
const _hoisted_69 = ["selected"]
const _hoisted_70 = { class: "admin-item-team-date" }
const _hoisted_71 = { key: 0 }
const _hoisted_72 = { class: "admin-item-actions" }
const _hoisted_73 = { class: "admin-action-link" }
const _hoisted_74 = ["onClick"]
const _hoisted_75 = ["onClick"]
const _hoisted_76 = ["onClick"]
const _hoisted_77 = {
  key: 0,
  class: "admin-item-box-btm join-team-details"
}
const _hoisted_78 = { class: "join-team-details-box" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_80 = [
  _hoisted_79
]
const _hoisted_81 = { class: "join-team-details-top" }
const _hoisted_82 = { class: "join-team-details-top-left" }
const _hoisted_83 = { class: "join-team-details-top-img" }
const _hoisted_84 = ["src"]
const _hoisted_85 = { class: "join-team-details-top-left-content" }
const _hoisted_86 = { class: "join-team-details-top-right" }
const _hoisted_87 = { class: "mail-text-row" }
const _hoisted_88 = { class: "mail-text-desc" }
const _hoisted_89 = { class: "mail-text-row" }
const _hoisted_90 = { class: "mail-text-desc" }
const _hoisted_91 = { class: "mail-text-row" }
const _hoisted_92 = { class: "mail-text-desc" }
const _hoisted_93 = { class: "mail-actions" }
const _hoisted_94 = { class: "attachment-box" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_96 = { class: "attachment-info" }
const _hoisted_97 = ["onClick"]
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_99 = [
  _hoisted_98
]
const _hoisted_100 = { class: "mail-ul-actions" }
const _hoisted_101 = ["onClick"]
const _hoisted_102 = ["onClick"]
const _hoisted_103 = { class: "reply-list-row" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reply-list-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  })
], -1))
const _hoisted_105 = { class: "reply-list-content" }
const _hoisted_106 = ["title"]
const _hoisted_107 = { class: "mail-text-row" }
const _hoisted_108 = { class: "mail-text-desc" }
const _hoisted_109 = ["innerHTML"]
const _hoisted_110 = { class: "admin-pagination-section" }
const _hoisted_111 = { class: "custom-row" }
const _hoisted_112 = { class: "item-show-selectbox" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "10" }, "10", -1))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "20" }, "20", -1))
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "50" }, "50", -1))
const _hoisted_116 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "100" }, "100", -1))
const _hoisted_117 = [
  _hoisted_113,
  _hoisted_114,
  _hoisted_115,
  _hoisted_116
]
const _hoisted_118 = {
  key: 0,
  class: "admin-pagination",
  id: "paginationBox"
}
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "pagination-previous"
}, null, -1))
const _hoisted_120 = [
  _hoisted_119
]
const _hoisted_121 = ["onClick"]
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "pagination-next"
}, null, -1))
const _hoisted_123 = [
  _hoisted_122
]
const _hoisted_124 = { key: 1 }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "No data to display", -1))
const _hoisted_126 = [
  _hoisted_125
]
const _hoisted_127 = { class: "admin-site-footer" }
const _hoisted_128 = { class: "container" }
const _hoisted_129 = {
  class: "modal fade confirmation-popup",
  id: "deletePop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_130 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_131 = { class: "modal-content" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirmation-popup-icon" }, [
  /*#__PURE__*/_createElementVNode("i", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_5,
      alt: ""
    })
  ])
], -1))
const _hoisted_133 = { class: "confirmation-popup-mid" }
const _hoisted_134 = { class: "confirmation-popup-btm" }
const _hoisted_135 = {
  id: "popNoBtn",
  class: "admin-btn-outline-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_136 = {
  class: "modal fade confirmation-popup",
  id: "followupPop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "followupModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_137 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_138 = { class: "modal-content followupPop" }
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirmation-popup-icon" }, [
  /*#__PURE__*/_createElementVNode("i", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_6,
      alt: ""
    })
  ])
], -1))
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirmation-popup-mid" }, " Are you sure, you want to follow up this? ", -1))
const _hoisted_141 = { class: "confirmation-popup-btm" }
const _hoisted_142 = {
  id: "popNoBtn",
  class: "admin-btn-outline-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_143 = {
  class: "modal fade confirmation-popup",
  id: "HiredPop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "HiredModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_144 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_145 = { class: "modal-content HiredPop" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirmation-popup-icon" }, [
  /*#__PURE__*/_createElementVNode("i", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_7,
      alt: ""
    })
  ])
], -1))
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirmation-popup-mid" }, " Are you sure, you want to hire this? ", -1))
const _hoisted_148 = { class: "confirmation-popup-btm" }
const _hoisted_149 = {
  id: "popNoBtn",
  class: "admin-btn-outline-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_150 = {
  class: "modal fade confirmation-popup",
  id: "rejectedPop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "rejectedModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_151 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_152 = { class: "modal-content rejectedPop" }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirmation-popup-icon" }, [
  /*#__PURE__*/_createElementVNode("i", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_8,
      alt: ""
    })
  ])
], -1))
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirmation-popup-mid" }, " Are you sure, you want to rejected this? ", -1))
const _hoisted_155 = { class: "confirmation-popup-btm" }
const _hoisted_156 = {
  id: "popNoBtn",
  class: "admin-btn-outline-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_157 = {
  class: "modal fade reply-popup",
  id: "replyPop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "replyModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_158 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_159 = { class: "modal-content" }
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "reply-pop-close",
  "data-bs-dismiss": "modal",
  id: "replyPopCloseBtn"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_161 = { class: "reply-form" }
const _hoisted_162 = { class: "admin-input-field" }
const _hoisted_163 = { class: "admin-input-field" }
const _hoisted_164 = { class: "admin-input-field" }
const _hoisted_165 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_166 = { class: "admin-input-field" }
const _hoisted_167 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_168 = { class: "admin-input-field-submit" }
const _hoisted_169 = {
  id: "servicesPgSubmitBtn",
  type: "submit",
  class: "admin-btn-outline-primary"
}
const _hoisted_170 = {
  type: "button",
  class: "dummy-btn",
  "data-bs-dismiss": "modal",
  ref: "dummyButton",
  style: {"display":"none"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adminHeader = _resolveComponent("adminHeader")!
  const _component_adminNavigation = _resolveComponent("adminNavigation")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_ckeditor = _resolveComponent("ckeditor")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_adminHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_adminNavigation),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.constants.JOIN_OUR_TEAM_TEXT), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "allLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'all' }),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchView('all')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.ALL_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.all), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "newApplicationLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'newApplication' }),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchView('newApplication')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.NEW_APPLICATION_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.newApplication), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "followUpLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'followUp' }),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchView('followUp')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.FOLLOW_UP_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.followUp), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "rejectedLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'rejected' }),
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchView('rejected')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.REJECTED_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.rejected), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "hiredLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'hired' }),
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.switchView('hired')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.HIRED_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.hired), 1)
                        ], 2)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        id: "seachJoinTeamInput",
                        type: "text",
                        placeholder: "Search",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchedText) = $event)),
                        onKeyup: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.fetchJoinTeams(_ctx.activeTab), _ctx.fetchCounts(_ctx.searchedText), _ctx.editFormSubmitted = false, _ctx.selectAll = false, _ctx.selectedJoinTeams = []), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.searchedText]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("ul", null, [
                        (_ctx.selectedJoinTeams.length > 1)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.selectedJoinTeams.length) + " entries selected", 1),
                              _createElementVNode("button", {
                                id: "tagCloseBtn",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedJoinTeams = [], _ctx.selectAll = false))
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.dateFilter === 'custom')
                          ? (_openBlock(), _createElementBlock("li", _hoisted_16, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.formatCustomDate(_ctx.startDate)) + "-" + _toDisplayString(_ctx.formatCustomDate(_ctx.endDate)), 1),
                              _createElementVNode("button", {
                                id: "tagCloseBtn",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.dateFilter = '', _ctx.fetchJoinTeams(_ctx.activeTab), _ctx.fetchCounts(), _ctx.limit = 10))
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.dateFilter === 'lastWeek')
                          ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                              _hoisted_18,
                              _createElementVNode("button", {
                                id: "tagCloseBtn",
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.dateFilter = '', _ctx.fetchJoinTeams(_ctx.activeTab), _ctx.fetchCounts(), _ctx.limit = 10))
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.dateFilter === 'lastMonth')
                          ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                              _hoisted_20,
                              _createElementVNode("button", {
                                id: "tagCloseBtn",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.dateFilter = '', _ctx.fetchJoinTeams(_ctx.activeTab), _ctx.fetchCounts(), _ctx.limit = 10))
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (_ctx.selectedJoinTeams.length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createElementVNode("button", {
                            class: "btn_link",
                            id: "deleteAllBtn",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#deletePop",
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setDeleteMode('all')))
                          }, _toDisplayString(_ctx.constants.DELETE_ALL_BUTTON), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.selectedJoinTeams.length > 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("button", {
                            class: "btn_link",
                            id: "downloadAllBtn",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.downloadResume('all')))
                          }, _toDisplayString(_ctx.constants.DOWNLOAD_ALL_BUTTON), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["date-filter-box", { 'show-date-dropdown': _ctx.showDateDropdown }]),
                      id: "dateFilterDropdown"
                    }, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("button", {
                          id: "dateFilterBtn",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showDateDropdown = true))
                        }, _hoisted_25)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["date-filter-dropdown", { 'show-custom-date': _ctx.showCustomDate }])
                      }, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("a", {
                            href: "#",
                            id: "lastWeeekLink",
                            class: "date-item",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.getDateFilteredData('lastWeek')))
                          }, _toDisplayString(_ctx.constants.LAST_WEEK_LINK), 1),
                          _createElementVNode("a", {
                            href: "#",
                            id: "lastMonthLink",
                            class: "date-item",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.getDateFilteredData('lastMonth')))
                          }, _toDisplayString(_ctx.constants.LAST_MONTH_LINK), 1),
                          _createElementVNode("a", {
                            href: "#",
                            id: "customDateLink",
                            onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => {_ctx.showCustomPicker = true; _ctx.showCustomDate = true}, ["prevent"]))
                          }, _toDisplayString(_ctx.constants.CUSTOM_DATE_LINK), 1)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          (_ctx.showCustomPicker)
                            ? (_openBlock(), _createBlock(_component_Datepicker, {
                                key: 0,
                                range: "",
                                "enable-time-picker": false,
                                clearable: false,
                                "menu-class-name": "custom-datepicker-menu",
                                inline: true,
                                onRangeStart: _ctx.onRangeStart,
                                onRangeEnd: _ctx.onRangeEnd
                              }, {
                                "action-buttons": _withCtx(() => [
                                  _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("button", {
                                      id: "cancelButton",
                                      class: "cancel-btn",
                                      onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.resetClasses && _ctx.resetClasses(...args)))
                                    }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1),
                                    _createElementVNode("button", {
                                      id: "doneButton",
                                      class: "apply-btn",
                                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleDate()))
                                    }, _toDisplayString(_ctx.constants.DONE_BUTTON), 1)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["onRangeStart", "onRangeEnd"]))
                            : _createCommentVNode("", true)
                        ])
                      ], 2)
                    ], 2)
                  ])
                ])
              ])
            ]),
            (_ctx.editJoinTeamsData.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(['admin-item-list-section admin-join-team-section', { 'show-edit-item-outer': _ctx.editFormSubmitted }])
                }, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("input", {
                                name: "cssCheckbox",
                                id: "selectAll",
                                type: "checkbox",
                                class: "css-checkbox",
                                onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args))),
                                checked: _ctx.selectAll === true
                              }, null, 40, _hoisted_35),
                              _hoisted_36
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.constants.IMAGE_LABEL), 1),
                          _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.constants.NAME_LABEL), 1),
                          _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.constants.EMAIL_LABEL), 1),
                          _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.constants.DESIGNATION_LABEL), 1),
                          _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.constants.NAME_OF_REFERENCE_LABEL), 1),
                          _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.constants.DESCRIPTION_LABEL), 1),
                          _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.constants.STATUS_LABEL), 1),
                          _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.constants.DATE_LABEL), 1),
                          _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.constants.ACTIONS_LABEL), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editJoinTeamsData, (joinTeam, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: joinTeam.id,
                              class: _normalizeClass(['admin-item-box', { 'show-edit-item': _ctx.editFormSubmitted }])
                            }, [
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("div", _hoisted_49, [
                                  _createElementVNode("div", _hoisted_50, [
                                    _createElementVNode("div", _hoisted_51, [
                                      _createElementVNode("input", {
                                        name: "cssCheckbox",
                                        id: 'demo_opt_' + joinTeam.id,
                                        type: "checkbox",
                                        class: "css-checkbox",
                                        onChange: ($event: any) => (_ctx.toggleJoinTeamSelection(joinTeam.id)),
                                        checked: _ctx.selectedJoinTeams.includes(joinTeam.id)
                                      }, null, 40, _hoisted_52),
                                      _createElementVNode("label", {
                                        for: 'demo_opt_' + joinTeam.id
                                      }, null, 8, _hoisted_53)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("div", _hoisted_55, [
                                      _createElementVNode("img", {
                                        src: _ctx.getCdnImageAddress(joinTeam.candidateImage, `w_40,h_41/`),
                                        alt: ""
                                      }, null, 8, _hoisted_56)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_57, [
                                    _createElementVNode("div", _hoisted_58, _toDisplayString(joinTeam.candidateName), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_59, _toDisplayString(joinTeam.email), 1),
                                  _createElementVNode("div", _hoisted_60, _toDisplayString(joinTeam.designation), 1),
                                  _createElementVNode("div", _hoisted_61, _toDisplayString(joinTeam.nameOfReference), 1),
                                  _createElementVNode("div", _hoisted_62, _toDisplayString(joinTeam.description), 1),
                                  _createElementVNode("div", _hoisted_63, [
                                    _createElementVNode("div", _hoisted_64, [
                                      _createElementVNode("select", {
                                        id: "statusSelectBox",
                                        class: "statusselectbox",
                                        onChange: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.onStatusChange && _ctx.onStatusChange(...args))),
                                        style: _normalizeStyle(_ctx.getStatusColor(joinTeam.status)),
                                        onClick: ($event: any) => (_ctx.personId(joinTeam.id))
                                      }, [
                                        _createElementVNode("option", {
                                          value: "new",
                                          selected: joinTeam.status === 0
                                        }, " New", 8, _hoisted_66),
                                        _createElementVNode("option", {
                                          value: "followup",
                                          selected: joinTeam.status === 1
                                        }, "Follow up", 8, _hoisted_67),
                                        _createElementVNode("option", {
                                          value: "hired",
                                          selected: joinTeam.status === 3
                                        }, " Hired", 8, _hoisted_68),
                                        _createElementVNode("option", {
                                          value: "rejected",
                                          selected: joinTeam.status === 4
                                        }, "Rejected", 8, _hoisted_69)
                                      ], 44, _hoisted_65)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_70, [
                                    (joinTeam.Created_at)
                                      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_71, [
                                          _createTextVNode(_toDisplayString(_ctx.formatDate(joinTeam.Created_at)), 1)
                                        ])), [
                                          [
                                            _directive_b_tooltip,
                                            { title: _ctx.formatDate(joinTeam.Created_at) },
                                            void 0,
                                            { up: true }
                                          ]
                                        ])
                                      : _createCommentVNode("", true)
                                  ]),
                                  _createElementVNode("div", _hoisted_72, [
                                    _createElementVNode("ul", _hoisted_73, [
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          class: "hide-row-btn",
                                          id: "joinTeamPgDeleteBtn",
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#deletePop",
                                          onClick: ($event: any) => (_ctx.setDeleteMode('single', joinTeam.id))
                                        }, _toDisplayString(_ctx.constants.DELETE_BUTTON), 9, _hoisted_74)
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          id: "joinTeamPgDwonloadBtn",
                                          onClick: ($event: any) => (_ctx.downloadResume('single', joinTeam.id, joinTeam.candidateName))
                                        }, _toDisplayString(_ctx.constants.DOWNLOAD_BUTTON), 9, _hoisted_75)
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          id: "teamPgPublishBtn",
                                          class: "viewbtn",
                                          onClick: ($event: any) => (_ctx.dummyfunction(index, joinTeam.id, joinTeam.email))
                                        }, _toDisplayString(_ctx.constants.VIEW_BUTTON), 9, _hoisted_76)
                                      ])
                                    ])
                                  ])
                                ])
                              ]),
                              (joinTeam.editing)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                    _createElementVNode("div", _hoisted_78, [
                                      _createElementVNode("button", {
                                        class: "viewclose",
                                        id: "viewCloseBtn",
                                        onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.editFormSubmitted = false))
                                      }, _hoisted_80),
                                      _createElementVNode("div", _hoisted_81, [
                                        _createElementVNode("div", _hoisted_82, [
                                          _createElementVNode("div", _hoisted_83, [
                                            _createElementVNode("img", {
                                              src: _ctx.editimageSrc || require('@/assets/images/admin-img/image-icon.svg'),
                                              alt: ""
                                            }, null, 8, _hoisted_84)
                                          ]),
                                          _createElementVNode("div", _hoisted_85, [
                                            _createElementVNode("h3", null, _toDisplayString(joinTeam.candidateName), 1),
                                            _createElementVNode("span", null, _toDisplayString(joinTeam.designation), 1)
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_86, [
                                          _createElementVNode("div", _hoisted_87, [
                                            _createElementVNode("label", null, _toDisplayString(_ctx.constants.EMAIL_LABEL), 1),
                                            _createElementVNode("div", _hoisted_88, _toDisplayString(joinTeam.email), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_89, [
                                            _createElementVNode("label", null, _toDisplayString(_ctx.constants.NAME_OF_REFERENCE_LABEL), 1),
                                            _createElementVNode("div", _hoisted_90, _toDisplayString(joinTeam.nameOfReference), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_91, [
                                            _createElementVNode("label", null, _toDisplayString(_ctx.constants.DESCRIPTION_LABEL), 1),
                                            _createElementVNode("div", _hoisted_92, _toDisplayString(joinTeam.description), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_93, [
                                            _createElementVNode("div", _hoisted_94, [
                                              _hoisted_95,
                                              _createElementVNode("div", _hoisted_96, [
                                                _createElementVNode("span", null, _toDisplayString(joinTeam.resumeName), 1),
                                                _createElementVNode("span", null, _toDisplayString(joinTeam.resumeSize), 1)
                                              ]),
                                              _createElementVNode("button", {
                                                class: "attachmentDownloadBtn",
                                                onClick: ($event: any) => (_ctx.downloadResume('single', joinTeam.id))
                                              }, _hoisted_99, 8, _hoisted_97)
                                            ]),
                                            _createElementVNode("ul", _hoisted_100, [
                                              _createElementVNode("li", null, [
                                                _createElementVNode("button", {
                                                  id: "replyMailBtn",
                                                  "data-bs-toggle": "modal",
                                                  "data-bs-target": "#replyPop",
                                                  onClick: ($event: any) => (_ctx.candidateId = joinTeam.id, _ctx.errMsg = '')
                                                }, _toDisplayString(_ctx.constants.REPLY_BUTTON), 9, _hoisted_101)
                                              ]),
                                              _createElementVNode("li", null, [
                                                _createElementVNode("button", {
                                                  id: "deleteMailBtn",
                                                  "data-bs-toggle": "modal",
                                                  "data-bs-target": "#deletePop",
                                                  onClick: ($event: any) => (_ctx.setDeleteMode('single', joinTeam.id))
                                                }, _toDisplayString(_ctx.constants.DELETE_BUTTON), 9, _hoisted_102)
                                              ])
                                            ])
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_103, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailThread, (thread, index) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            class: "reply-list-box",
                                            key: index
                                          }, [
                                            _hoisted_104,
                                            _createElementVNode("div", _hoisted_105, [
                                              _createElementVNode("strong", null, [
                                                _createTextVNode("Subject : " + _toDisplayString(thread.subject) + " ", 1),
                                                _withDirectives((_openBlock(), _createElementBlock("span", {
                                                  title: _ctx.formatDate(thread.Created_at),
                                                  "data-bs-toggle": "tooltip"
                                                }, [
                                                  _createTextVNode(_toDisplayString(thread.relativeEmailPostDate), 1)
                                                ], 8, _hoisted_106)), [
                                                  [
                                                    _directive_b_tooltip,
                                                    void 0,
                                                    void 0,
                                                    { up: true }
                                                  ]
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_107, [
                                                _createElementVNode("label", null, "Hi " + _toDisplayString(thread.candidateName), 1),
                                                _createElementVNode("div", _hoisted_108, [
                                                  _createElementVNode("p", {
                                                    innerHTML: thread.emailContent
                                                  }, null, 8, _hoisted_109)
                                                ])
                                              ])
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ], 512)
                      ])
                    ])
                  ], 512),
                  _createElementVNode("div", _hoisted_110, [
                    _createElementVNode("div", _hoisted_111, [
                      _createElementVNode("div", _hoisted_112, [
                        _withDirectives(_createElementVNode("select", {
                          id: "paginationSelectBox",
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.limit) = $event)),
                          onChange: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.handleLimitChange && _ctx.handleLimitChange(...args)))
                        }, _hoisted_117, 544), [
                          [_vModelSelect, _ctx.limit]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.ENTRIES_PER_PAGE_LABEL), 1)
                      ]),
                      (_ctx.totalPages > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_118, [
                            _createElementVNode("ul", null, [
                              (_ctx.currentPage !== 1)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 0,
                                    onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
                                  }, _hoisted_120))
                                : _createCommentVNode("", true),
                              (_ctx.totalPages != 1)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.visiblePages, (page) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: page,
                                      onClick: ($event: any) => (_ctx.changePage(page))
                                    }, [
                                      _createElementVNode("a", {
                                        href: "#",
                                        class: _normalizeClass({ active: _ctx.currentPage === page })
                                      }, _toDisplayString(page), 3)
                                    ], 8, _hoisted_121))
                                  }), 128))
                                : _createCommentVNode("", true),
                              (_ctx.currentPage !== _ctx.totalPages)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 2,
                                    onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
                                  }, _hoisted_123))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2))
              : (_openBlock(), _createElementBlock("div", _hoisted_124, _hoisted_126))
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_127, [
      _createElementVNode("div", _hoisted_128, _toDisplayString(_ctx.constants.COPYRIGHT_TEXT), 1)
    ]),
    _createElementVNode("div", _hoisted_129, [
      _createElementVNode("div", _hoisted_130, [
        _createElementVNode("div", _hoisted_131, [
          _hoisted_132,
          _createElementVNode("div", _hoisted_133, [
            _createElementVNode("p", null, _toDisplayString(_ctx.constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT), 1)
          ]),
          _createElementVNode("div", _hoisted_134, [
            _createElementVNode("button", _hoisted_135, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              id: "popYesBtn",
              class: "admin-btn-outline-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_136, [
      _createElementVNode("div", _hoisted_137, [
        _createElementVNode("div", _hoisted_138, [
          _hoisted_139,
          _hoisted_140,
          _createElementVNode("div", _hoisted_141, [
            _createElementVNode("button", _hoisted_142, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              id: "popYesBtn",
              class: "admin-btn-outline-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.confirmStatusChange && _ctx.confirmStatusChange(...args)))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_143, [
      _createElementVNode("div", _hoisted_144, [
        _createElementVNode("div", _hoisted_145, [
          _hoisted_146,
          _hoisted_147,
          _createElementVNode("div", _hoisted_148, [
            _createElementVNode("button", _hoisted_149, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              id: "popYesBtn",
              class: "admin-btn-outline-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.confirmStatusChange && _ctx.confirmStatusChange(...args)))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_150, [
      _createElementVNode("div", _hoisted_151, [
        _createElementVNode("div", _hoisted_152, [
          _hoisted_153,
          _hoisted_154,
          _createElementVNode("div", _hoisted_155, [
            _createElementVNode("button", _hoisted_156, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              id: "popYesBtn",
              class: "admin-btn-outline-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.confirmStatusChange && _ctx.confirmStatusChange(...args)))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_157, [
      _createElementVNode("div", _hoisted_158, [
        _createElementVNode("div", _hoisted_159, [
          _hoisted_160,
          _createElementVNode("h2", null, "Reply to " + _toDisplayString(_ctx.editJoinTeamData.candidateName), 1),
          _createElementVNode("div", _hoisted_161, [
            _createElementVNode("form", {
              id: "emailReplyForm",
              onSubmit: _cache[35] || (_cache[35] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_162, [
                _createElementVNode("label", null, _toDisplayString(_ctx.constants.NAME_LABEL), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "replyNameInput",
                  type: "text",
                  placeholder: "Enter the Name",
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.editJoinTeamData.candidateName) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.editJoinTeamData.candidateName]
                ])
              ]),
              _createElementVNode("div", _hoisted_163, [
                _createElementVNode("label", null, _toDisplayString(_ctx.constants.EMAIL_LABEL), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "replyNameInput",
                  type: "text",
                  placeholder: "Enter the Email",
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.editJoinTeamData.email) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.editJoinTeamData.email]
                ])
              ]),
              _createElementVNode("div", _hoisted_164, [
                _createElementVNode("label", null, _toDisplayString(_ctx.constants.SUBJECT_LABEL), 1),
                _withDirectives(_createElementVNode("input", {
                  id: "replyNameInput",
                  type: "text",
                  placeholder: "Enter the Subject",
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.newEmail.subject) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.newEmail.subject]
                ]),
                (!_ctx.newEmail.subject)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_165, _toDisplayString(_ctx.errMsg), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_166, [
                _createElementVNode("label", null, _toDisplayString(_ctx.constants.DESCRIPTION_LABEL), 1),
                _createVNode(_component_ckeditor, {
                  placeholder: "Description",
                  class: "text-editer",
                  id: "replyDescInput",
                  editor: _ctx.editor,
                  modelValue: _ctx.newEmail.description,
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.newEmail.description) = $event)),
                  config: _ctx.editorConfig
                }, null, 8, ["editor", "modelValue", "config"]),
                (!_ctx.newEmail.description)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_167, _toDisplayString(_ctx.errMsg), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_168, [
                _createElementVNode("button", _hoisted_169, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 1),
                _createElementVNode("button", _hoisted_170, null, 512),
                _createElementVNode("button", {
                  id: "servicesPgSubmitBtn",
                  type: "button",
                  class: "admin-btn-outline-secondary",
                  "data-bs-dismiss": "modal",
                  onClick: _cache[34] || (_cache[34] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)), ["prevent"]))
                }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
              ])
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}